import clx from 'classnames';
import { useModal } from 'context/Modal/Context';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import Link from 'next/link';
import ThumbnailItem from './ThumbnailItem';
import { ThumbnailType } from './type';

const Thumbnails = ({ thumbnails }: { thumbnails: ThumbnailType[] }) => {
  const { openModal } = useModal();

  return (
    <ul className="flex md:justify-center items-center flex-wrap md:gap-0 justify-start">
      {thumbnails.map(({ src, zoom, link, ...props }) => (
        <div
          key={src}
          className={clx('p-2 flex justify-center', `md:basis-1/${Math.min(thumbnails.length, 4)} basis-1/2`)}
        >
          {zoom && (
            <button
              className="hover:-translate-y-2 transition duration-quick"
              onClick={() =>
                openModal(MODAL_NAME.ZOOM, {
                  imagePath: zoom,
                  linkProps: link ? { label: link.title, href: link.url } : undefined,
                })
              }
              type="button"
            >
              <ThumbnailItem src={src} {...props} />
            </button>
          )}
          {link && !zoom && (
            <Link className="hover:-translate-y-2 transition duration-quick" href={link.url}>
              <ThumbnailItem src={src} {...props} />
            </Link>
          )}
          {!link && !zoom && <ThumbnailItem src={src} {...props} />}
        </div>
      ))}
    </ul>
  );
};
export default Thumbnails;
